import { useI18N } from "@src/language/language-context";

const useOrganizationsViewAdminPanelHook = () => {
  const i18n = useI18N();
  const texts = {
    title: i18n("modules.organizationsViewAdminPanel.title"),
    description: i18n("modules.organizationsViewAdminPanel.description"),
  };

  return {
    texts,
  };
};

export default useOrganizationsViewAdminPanelHook;
